/*
  clikt. — discourage lifting the photography.

  Right-click is blocked and images cannot be dragged out of the page. Text
  fields are left alone: someone filling in the enquiry form still needs the
  right-click menu to paste an address or fix a spelling, and taking that
  away punishes the customer rather than the copier.

  Worth knowing: this is a deterrent, not protection. Anything the browser
  displays it has already downloaded, and the file is still reachable
  through the page source or a screenshot. It stops the casual save, which
  is the behaviour actually worth stopping.
*/
(function () {
  const TYPEABLE = 'input, textarea, select, [contenteditable="true"]';

  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest(TYPEABLE)) return;
    e.preventDefault();
  });

  // Dragging an image to the desktop is the other one-gesture save.
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG' || e.target.closest('picture, .media, svg')) e.preventDefault();
  });
})();
